export default __webpack_public_path__ + "static/media/tpp-unlimited-online-chat.eee4cec4.svg";